'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Subject2 = require('rxjs/Subject');

var _StateMutation = require('../states/mutation/StateMutation');

var _StateMutation2 = _interopRequireDefault(_StateMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StateMutationSubject = function (_Subject) {
  _inherits(StateMutationSubject, _Subject);

  function StateMutationSubject(form) {
    _classCallCheck(this, StateMutationSubject);

    var _this = _possibleConstructorReturn(this, (StateMutationSubject.__proto__ || Object.getPrototypeOf(StateMutationSubject)).call(this));

    _this.isRunOnSubscribe = false;
    _this.mutatedFields = [];


    _this.form = form;
    _this.subscription = form.stateObservable.subscribe(_this);
    return _this;
  }

  _createClass(StateMutationSubject, [{
    key: 'unsubscribe',
    value: function unsubscribe() {
      _get(StateMutationSubject.prototype.__proto__ || Object.getPrototypeOf(StateMutationSubject.prototype), 'unsubscribe', this).call(this);

      this.subscription.unsubscribe();
    }
  }, {
    key: 'subscribe',
    value: function subscribe(observer) {
      var subscription = _get(StateMutationSubject.prototype.__proto__ || Object.getPrototypeOf(StateMutationSubject.prototype), 'subscribe', this).call(this, observer);

      if (this.isRunOnSubscribe) {
        _get(StateMutationSubject.prototype.__proto__ || Object.getPrototypeOf(StateMutationSubject.prototype), 'next', this).call(this, {});
      }

      return subscription;
    }

    /**
     * Extended
     * @param {StateMutation} state
     */

  }, {
    key: 'next',
    value: function next(state) {
      if (this.mutatedFields.length && !this.mutatedFields.filter(function (p) {
        return Object.hasOwnProperty.call(state.mutations, p);
      }).length) {
        return;
      }

      _get(StateMutationSubject.prototype.__proto__ || Object.getPrototypeOf(StateMutationSubject.prototype), 'next', this).call(this, state);
    }

    /**
     * Run observers when they has been subscribed
     * @returns {StateMutationSubject}
     */

  }, {
    key: 'whenSubscribed',
    value: function whenSubscribed() {
      this.isRunOnSubscribe = true;

      return this;
    }

    /**
     * When form state changed
     * @param {Array<string>} properties
     * @returns {StateMutationSubject}
     */

  }, {
    key: 'when',
    value: function when() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.mutatedFields = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(this.mutatedFields), _toConsumableArray(properties)))));

      return this;
    }
  }]);

  return StateMutationSubject;
}(_Subject2.Subject);

exports.default = StateMutationSubject;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/rx/StateMutationSubject.js
// module id = 755
// module chunks = 0